/* global oyc */
oyc.Dependency = {
  noAutoLoad: true,
  loaded: [],
  load: function (lib) {
    var promises = [];
    if ('dependencies' in lib) {
      for (var i = 0; i < lib.dependencies.length; i++) {
        var dep = lib.dependencies[i];
        if (dep.match(/\//) !== null) {
          // a file path or url is given - load a file from an url
          if (this.loaded.indexOf(dep) === -1) {
            promises.push(oyc.AssetLoader.loadAsset(dep));
            this.loaded.push(dep);
          }
        } else {
          var depPromises = [];
          if ('dependencies' in oyc[dep]) {
            depPromises = this.load(oyc[dep]);
          }
          if (this.loaded.indexOf(dep) === -1 && typeof oyc[dep].init === 'function' && (!('noAutoLoad' in oyc[dep]) || !oyc[dep].noAutoLoad)) {
            if (0 < depPromises.length) {
              promises.push(Promise.all(depPromises).then(oyc[dep].init()));
            } else {
              promises.push(oyc[dep].init());
            }
            this.loaded.push(dep);
          }
          lib[dep] = oyc[dep];
        }
      }
    }
    return promises;
  }
}